import React from 'react';
import { Box, HStack } from '@chakra-ui/react';

const ChatLoadingDots = ({ size = 'md', color = 'gray.500' }) => {
  const dotSize = size === 'sm' ? '6px' : size === 'lg' ? '10px' : '8px';
  
  return (
    <HStack spacing={1} align="center">
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          w={dotSize}
          h={dotSize}
          bg={color}
          borderRadius="full"
          animation={`bounce 1.4s ease-in-out infinite both`}
          animationDelay={`${index * 0.16}s`}
          sx={{
            '@keyframes bounce': {
              '0%, 80%, 100%': {
                transform: 'scale(0)',
                opacity: 0.5,
              },
              '40%': {
                transform: 'scale(1)',
                opacity: 1,
              },
            },
          }}
        />
      ))}
    </HStack>
  );
};

export default ChatLoadingDots; 